import L from 'leaflet';

import { mapManagement } from './management/map-management';
import { timeManagement } from './management/time-management';
import { layerManagement } from './management/layer-management';
import { controlManagement } from './management/control-management';

const DEFAULTS = {
	parentNode: null,
	language: 'de',
};

/**
 * @extends {L.Evented}
 */
class Widget extends L.Evented {
	/**
	 * @param {HTMLElement|string} [options.parentNode]
	 * @param {string} [options.language=de]
	 * @param {object} options.map Will be passed directory to {@link MapManagement}.
	 * @param {object} options.time Will be passed directory to {@link TimeManagement}.
	 * @param {object} options.layers Will be passed directory to {@link LayerManagement}.
	 * @param {object} options.controls Will be passed directory to {@link ControlManagement}.
	 */
	constructor(options) {
		super();

		this.options = Object.assign({}, DEFAULTS, options);

		this._container = L.DomUtil.create('div', 'widget');

		this.map = mapManagement(this, this.options.map);
		this.time = timeManagement(this, this.options.time);
		this.layers = layerManagement(this, this.options.layers);
		this.controls = controlManagement(this, this.options.controls);

		this.appendTo(this.options.parentNode);
	}

	/**
	 * @param {HTMLElement|string} container
	 */
	appendTo(container) {
		container = L.DomUtil.get(container);

		if (container instanceof HTMLElement) {
			this.options.parentNode = container;
			container.appendChild(this._container);

			this.map._map.invalidateSize(false);
			this.map._map.setView(this.options.map.center, this.options.map.zoom);
		}
	}

	destroy() {
		L.DomUtil.remove(this._container);

		this.map.destroy();
		this.time.destroy();
		this.layers.destroy();
		this.controls.destroy();
	}
}

export function widget(options) {
	return new Widget(options);
}

export default Widget;
